export default __webpack_public_path__ + "static/media/deleteAddress.baedf313.png";